// ** Styles
import { useState, useCallback } from 'react';
import '@styles/react/apps/app-roads.scss';
import WizardHorizontal from '../shared/Wizard';

const values = {
  video: {
    status: 'initial',
    name: '',
    description: '',
    video: ''
  },
  form: {
    status: 'initial',
    name: '',
    description: '',
    form: []
  },
  friends: {
    status: 'initial',
    name: '',
    description: '',
    friends: ''
  },
  audio: {
    status: 'initial',
    name: '',
    description: '',
    audio: '',
    cover: ''
  },
  checklist: {
    status: 'initial',
    name: '',
    description: '',
    list: []
  },
};

const NewActivity = () => {
  const [type, setType] = useState('form');
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(values[type]);
  const handleChangeType = useCallback((newType) => {
    setLoading(true);

    setData(values[newType]);
    setTimeout(() => {
      setType(newType);
      setLoading(false);
    }, 1);
  }, []);

  return !loading ? (
    <WizardHorizontal
      editMode={false}
      defaultValues={data}
      handleChangeType={handleChangeType}
      type={type}
      loading={loading}
      data={data}
      setData={setData}
    />
  ) : null;
};

export default NewActivity;
